// Maximum characters allowed in custom instructions for AI review prompts.
// This limit applies to new instructions only; existing longer instructions are grandfathered.
export const CUSTOM_INSTRUCTIONS_MAX_LENGTH = 10000;

// Maximum characters allowed for custom PR summary instructions.
export const SUMMARY_INSTRUCTIONS_MAX_LENGTH = 10000;

// Maximum characters allowed for custom auto-approve prompts.
export const AUTO_APPROVE_CUSTOM_PROMPT_MAX_LENGTH = 10000;

// Maximum characters allowed for custom auto-ultrareview trigger prompts.
export const AUTO_ULTRAREVIEW_CUSTOM_PROMPT_MAX_LENGTH = 10000;

// Maximum characters allowed for repository instructions to cubic's coding agent.
export const CODING_AGENT_INSTRUCTIONS_MAX_LENGTH = 10000;

// Maximum characters allowed for a repository's Verify instructions about its demos.
export const VERIFY_INSTRUCTIONS_MAX_LENGTH = 10000;

// Backed by a PostgreSQL INTEGER column.
export const MAX_CHANGED_LINES_LIMIT = 2_147_483_647;

// Canonical category for user-authored custom review rules.
export const CUSTOM_RULE_CATEGORY = 'Custom' as const;
export type CustomRuleCategory = typeof CUSTOM_RULE_CATEGORY;

// Maximum characters for custom rule fields (injected into AI prompts).
export const CUSTOM_RULE_TITLE_MAX_LENGTH = 200;
export const CUSTOM_RULE_DESCRIPTION_MAX_LENGTH = 10000;
export const CUSTOM_RULE_PATTERNS_MAX_LENGTH = 2_000;

// Threshold (0-1) at which character counters become visible in input fields.
export const CHARACTER_COUNTER_VISIBILITY_THRESHOLD = 0.8;
